(() => {
  const locale = String(document.documentElement.lang || '').toLowerCase();
  if (!locale.startsWith('fi')) return;
  const NBSP = '\u00A0';
  let queued = false;

  function formatTextNode(node) {
    if (!node || node.nodeType !== Node.TEXT_NODE || !node.nodeValue || !node.nodeValue.includes('€')) return;
    const parent = node.parentElement;
    if (!parent || /^(SCRIPT|STYLE|TEXTAREA|NOSCRIPT|OPTION)$/i.test(parent.tagName)) return;
    const next = node.nodeValue
      .replace(/€\s*([0-9]+(?:[.,][0-9]{1,2})?)/g, `$1${NBSP}€`)
      .replace(/([0-9])\s*€/g, `$1${NBSP}€`);
    if (next !== node.nodeValue) node.nodeValue = next;
  }

  function formatVisiblePrices() {
    if (!document.body) return;
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) formatTextNode(node);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      formatVisiblePrices();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
  document.addEventListener('change', () => setTimeout(schedule, 0), { passive: true });
})();

/* L4M locale-safe internal links. Kept in JS so Liquid/theme rendering remains untouched. */
(() => {
  const language = String(document.documentElement.lang || '').toLowerCase().split('-')[0];
  const localizedLanguages = new Set(['fi','et','de','ru','sv','da','pl','lt','lv','cs','nl']);
  if (!localizedLanguages.has(language)) return;

  const prefix = `/${language}`;
  const targets = ['/products/', '/collections/', '/pages/', '/blogs/', '/policies/'];

  function localizeAnchor(anchor) {
    if (!anchor || !anchor.getAttribute) return;
    const href = anchor.getAttribute('href');
    if (!href || !href.startsWith('/') || href.startsWith('//')) return;
    if (href === prefix || href.startsWith(prefix + '/')) return;
    if (!targets.some((base) => href.startsWith(base))) return;
    anchor.setAttribute('href', prefix + href);
  }

  function localizeWithin(root) {
    if (!root) return;
    if (root.matches && root.matches('a[href]')) localizeAnchor(root);
    if (root.querySelectorAll) root.querySelectorAll('a[href]').forEach(localizeAnchor);
  }

  function init() {
    localizeWithin(document);
    if (!document.body) return;
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) localizeWithin(node);
        });
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
